import { Line } from '../../../Common/Charts/Line';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIDCREASChartsDataContext } from './hooks/useIDCREASChartsDataContext';

export const GeneralEvolutionChart = () => {
    const { chartData } = useIDCREASChartsDataContext();

    return (
        <Line
            title="Evolução Anual do IDCREAS"
            subtitles={chartData.general.map((item) => getYearLabel(item.ano))}
            values={chartData.general.map(
                (item) => Number(item.idcreas) || 0
            )}
        />
    );
};
